module.exports = __webpack_public_path__ + "static/media/overheard-bubble-partners.8f36168d.jpg";